<template>
    <section class="quote light purple">
        <circles-layout></circles-layout>

        <v-quote>We hebben in dit uitdagende jaar de onderwijskwaliteit overeind weten te houden. Gesteund door de digitale wereld, maar vooral dankzij de kracht van studenten en medewerkers. Hun creativiteit, flexibiliteit en betrokkenheid zorgden ervoor dat de student centraler stond dan ooit tevoren.</v-quote>

        <v-author>– Carl Govers, Lid College van Bestuur</v-author>
    </section>
</template>

<style lang="scss" scoped>
    // see /static/scss/pages/_tekst.scss
</style>

<script>
    import Circles from '@/app/components/circles';
    import Quote from '@/app/components/quotations';
    import QuoteAuthor from '@/app/components/quotation-author';

    export default {
        name: 'OntwikkelingIntroQuote',
        meta: {
            title: 'OntwikkelingIntroQuote',
            color: '#a5147e'
        },
        components: {
            'circles-layout': Circles,
            'v-quote': Quote,
            'v-author': QuoteAuthor
        },
        methods: {
            focus()
            {
                // console.log( 'animateIn' );
            }
        }
    };
</script>
